<template>
  <div class="write-area">
    <div class="sel-image-view" :class="{'with-reply-comment':hasSubTitle}" v-show="attachedImage">
      <div class="dimd dimd-dark"></div>
      <div class="sel-image-block">
        <img :src="attachedImage" class="sel-image">
      </div>
      <div class="close-btn-group">
        <img src="@/assets/svg/close_btn.svg"
             @click="clearAttached" class="icon-control" aria-label="close"/>
      </div>
    </div>
    <div class="sel-reply-comment-view" v-show="replyComment.num">
      <div class="dimd dimd-gray"></div>
      <div class="reply_original-content-group">
        <div class="reply_preview-image" >
          <img :src="replyComment.imagePath" v-show="replyComment.imagePath">
        </div>
        <div class="reply_original-content">
          <div class="user-name">{{ replyComment.username }}</div>
          <div class="user-comment" v-html="replyComment.content"></div>
        </div>
      </div>
      <div class="close-btn-group">
        <img src="@/assets/svg/close_btn.svg"
             @click="clearReplyComment" class="icon-control" aria-label="close"/>
      </div>
    </div>
    <div class="sel-reply-comment-view" v-show="originalComment.num">
      <div class="dimd dimd-gray"></div>
      <div class="reply_original-content-group">
        <div class="reply_preview-image" >
          <img :src="originalComment.imagePath" v-show="originalComment.imagePath">
        </div>
        <div class="reply_original-content">
          <div class="user-name">[내 글을 수정하고 있습니다.]</div>
          <div class="user-comment" v-html="originalComment.content"></div>
        </div>
      </div>
      <div class="close-btn-group">
        <img src="@/assets/svg/close_btn.svg"
             @click="clearOrignalComment" class="icon-control" aria-label="close"/>
      </div>
    </div>
    <div class="inputform">
      <form name="cform">
        <div class="detail-form">
          <div class="article-reply-control-group">
            <textarea
                id="replyContentTextarea"
                :placeholder="textPlaceHolder"
                ref="myTextarea"
                rows="1"
                v-model="replyContent"/>
            <input type="file"
                   id="fileUpload"
                   name="fileUpload"
                   ref="fileUpload"
                   style="display: none"
                   @change="fileUpload($event)"/>
            <div class="control-button">
              <svg xmlns="http://www.w3.org/2000/svg"
                   @click="showEmoticonLayer"
                   class="svg-emoticon"
                   viewBox="0 0 92 92" width="32">
                <g transform="translate(16 16)">
                  <path
                      d="M598,1147a30,30,0,1,1,30-30A30,30,0,0,1,598,1147Zm0-56.25A26.25,26.25,0,1,0,624.25,1117,26.25,26.25,0,0,0,598,1090.75Z"
                      id="surface"
                      transform="translate(-568 -1087)"></path>
                  <circle cx="4" cy="4" r="4" transform="translate(16 20)"></circle>
                  <circle cx="4" cy="4" r="4"
                          transform="translate(36 20)"></circle>
                  <path d="M711.833,1081.486s-.691,5.234,5.234,5.234,5.234-5.234,5.234-5.234"
                        transform="translate(-687.067 -1046.323)"
                        fill="none"
                        id="mouse"
                        stroke="#7c7c7c"
                        stroke-linecap="round"
                        stroke-width="4"></path>
                </g>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 92 92"
                   class="svg-file-upload"
                   @click="callFileUpload">
                <path
                    d="M412.5,159h-45a7.5,7.5,0,0,1-7.5-7.5v-45a7.5,7.5,0,0,1,7.5-7.5h45a7.5,7.5,0,0,1,7.5,7.5v45A7.5,7.5,0,0,1,412.5,159Zm0-3.75a3.75,3.75,0,0,0,3.75-3.75v-15L405,125.248l-16.006,16.006,13.815,14Zm-48.75-3.75a3.75,3.75,0,0,0,3.75,3.75h30L378.647,136.4l-14.9,13.341Zm52.5-45a3.75,3.75,0,0,0-3.75-3.75h-45a3.75,3.75,0,0,0-3.75,3.75v38.131l15-13.756,7.609,7.709L405,119.625l11.25,11.49ZM375,121.5a7.5,7.5,0,1,1,7.5-7.5A7.5,7.5,0,0,1,375,121.5Zm0-11.25a3.75,3.75,0,1,0,3.75,3.75A3.75,3.75,0,0,0,375,110.25Z"
                    transform="translate(-344 -83)"
                    fill="#7c7c7c"/>
              </svg>
            </div>
          </div>
          <div class="submit-control-button">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"
                 class="svg-btn-submit"
                 @click="setReplyRegister">
              <g transform="translate(-934 -1173)">
                <circle cx="46" cy="46" r="60" transform="translate(948 1187)" fill="#2f8ce7"/>
                <path
                    d="M420.724,1134.54l-11.849-11.849v30.434a2.875,2.875,0,1,1-5.75,0V1122.69l-11.849,11.849a2.875,2.875,0,1,1-4.066-4.066l16.264-16.263a4.649,4.649,0,0,1,5.052,0l16.264,16.263a2.875,2.875,0,0,1-4.066,4.066Z"
                    transform="translate(587.632 98.585)" fill="#fff"/>
              </g>
              <rect width="120" height="120" fill="none"/>
            </svg>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReplyRegForm",
  props: {
    oProfile: Object,
    nParentReplyNum: Number,
    pBoardId: Number,
    pBoardSeq: Number
  },
  watch: {
    replyContent() {
      this.resizeTextarea()
    }
  },
  computed: {
    attachedImage() {
      if (this.emoticon.path) {
        return this.emoticon.path;
      } else if (this.attach.path) {
        return this.attach.path
      }
      return ''
    },
    hasSubTitle() {
      return this.replyComment.num || this.originalComment.num
    }
  },
  data() {
    return {
      replyContent: '',
      isSending: false,
      textPlaceHolder : "댓글을 입력해 주세요.",
      replyComment: {
        username: '',
        imageType : '',
        imagePath  : '',
        content: '',
        num: 0,
      },
      attach: {
        num: 0,
        path: '',
        obj: null
      },
      emoticon: {
        num: 0,
        path: ''
      },
      originalComment: {
        num: 0,
        content: '',
      }
    }
  },
  methods: {
    resizeTextarea() {
      const obj = document.getElementById("replyContentTextarea")
      const maxHeight = parseInt(window.getComputedStyle(obj).maxHeight)
      obj.style.height = "1px";
      obj.style.height = Math.min(maxHeight, obj.scrollHeight) + "px";
      console.log('resized complete')
    },
    clearAttached() {
      this.clearEmoticon()
      this.clearAttach()
    },
    clearEmoticon() {
      this.emoticon = {
        num: 0,
        path: ''
      }
    },
    clearAttach() {
      this.attach = {
        num: 0,
        path: '',
        obj: null
      }
    },
    clearReplyComment() {
      this.replyComment = {
        username: '',
        imageType : '',
        imagePath  : '',
        content: '',
        num: 0,
      }
      this.textPlaceHolder = "댓글을 입력해 주세요.";
    },
    clearOrignalComment() {
      this.originalComment = {
        num: 0
      }
    },
    clearForm() {
      this.replyContent = ''
      this.clearReplyComment()
      this.clearAttached()
      this.clearOrignalComment()
    },
    initForm(obj) {
      this.textPlaceHolder = "댓글을 입력해 주세요.";
      // 댓글 작성시
      if (Object.prototype.hasOwnProperty.call(obj, "reply")) {
        this.replyComment.username = obj.reply.username
        this.replyComment.content = obj.reply.conetent
        this.replyComment.num = obj.reply.comment_num
        this.replyComment.imageType = obj.reply.imageType
        this.replyComment.imagePath = obj.reply.imagePath
        if( !this.replyComment.content ){
          if( obj.reply.imageType === "emoticon") {
            this.replyComment.content = "이모티콘"
          }
          else if( obj.reply.imageType === "attach") {
            this.replyComment.content = "사진"
          }
        }
        this.textPlaceHolder = "대댓글을 입력해 주세요.";
        this.clearOrignalComment()
      }
      // 댓글 수정시
      else if (Object.prototype.hasOwnProperty.call(obj, "origin")) {
        this.clearReplyComment()
        this.replyContent = obj.origin.conetent
        this.originalComment.num = obj.origin.comment_num
        this.originalComment.content = obj.origin.conetent
        const origin = obj.origin
        if (Object.prototype.hasOwnProperty.call(origin, "emoticon") && origin.emoticon.num) {
          this.emoticon.num = origin.emoticon.num
          this.emoticon.path = process.env.VUE_APP_CDN + origin.emoticon.strFilePath
        }
        if (Object.prototype.hasOwnProperty.call(origin, "attach") && origin.attach.num) {
          this.attach.num = origin.attach.num
          this.attach.path = process.env.VUE_APP_MOBIGO_URL + origin.attach.strFilePath
        }
      }
      // 반영이후에 리사이징 처리해줘야 함.
      this.$nextTick(() => {
        this.resizeTextarea()
      })
    },
    // 이모티콘 팝업 Load
    showEmoticonLayer() {
      let width = screen.width;
      let height = screen.height * 0.35;
      const prevBackKeyEvent = window.callbackBackKey
      const panel = this.$showPanel({
        component: () => import('@/views/slide/Emoticon'),
        openOn: 'bottom',
        width: width,
        height: height
      });
      panel.promise.then(result => {
        window.callbackBackKey = prevBackKeyEvent ;
        if (result.num) {
          this.emoticon.num = result.num
          this.emoticon.path = process.env.VUE_APP_CDN + result.file_path
          this.clearAttach()
        } else {
          this.clearEmoticon()
        }
      });
    },
    callFileUpload() {
      const obj = this.$refs.fileUpload
      obj.value = null
      obj.click()
    },
    // 파일 업로드
    fileUpload(e) {
      const Target = e.target
      const oFile = Target.files[0]

      if (!oFile.type.match("image.*")) {
        alert("확장자는 이미지 확장자만 가능합니다.");
        return;
      }

      if (oFile.size > process.env.VUE_APP_COMMENT_ATTACH_MAX_SIZE){
        alert("이미지는 5M 이하까지 등록 가능합니다.");
        return;
      }

      var image = this.attach;
      var reader = new FileReader();
      this.clearEmoticon()
      reader.onload = function (e) {
        image.path = e.target.result
      }
      reader.readAsDataURL(oFile);
      image.obj = oFile
    },

    setReplyRegister() {
      // 더블클릭 방지 체크
      if (this.isSending) {
        return false;
      }
      this.isSending = true;
      let formData = new FormData();
      formData.append('strReplyContent', this.replyContent);
      formData.append('nComtNum', this.originalComment.num);
      formData.append('p_num', this.replyComment.num);
      if (this.emoticon.num > 0) {
        formData.append('image_type', 'emoticon');
        formData.append('emoticon_num', this.emoticon.num);
      } else if (this.attach.path) {
        formData.append('image_type', 'file');
        formData.append('attach_num', this.attach.num);
        formData.append('fileUpload', document.cform.fileUpload.files[0]);
      } else {
        formData.append('image_type', 'none');
      }
      const url = '/api/v1/reply/register/' + this.pBoardId + '/' + this.pBoardSeq + '/' + this.nParentReplyNum
      this.ajaxUpload(url, formData, this.setReplyRegisterResult);
    },
    // 댓글 등록, 수정 결과
    setReplyRegisterResult(response) {
      if (response.result.code == 0) {
        this.$emit("reloadReply")
        this.toastMsg(response.result.resultNoti.message, 1500, 'middle');
      } else {
        this.toastMsg(response.result.resultNoti.message, 1500);
      }
      this.clearForm()
      this.isSending = false;
    },

  }
}
</script>

<style scoped>

svg.svg-emoticon {
  fill: #7c7c7c;
  cursor: pointer;
  width: 32px;
  height: 32px;
}

svg.svg-emoticon:hover path#mouse {
  stroke: #2f8ce7;
}

svg.svg-emoticon:hover path#surface {
  fill: #2f8ce7;
}

svg.svg-emoticon:hover circle {
  fill: #2f8ce7;
}

svg.svg-file-upload {
  fill: #7c7c7c;
  cursor: pointer;
  width: 32px;
  height: 32px;
  margin-left: 5px;
}

svg.svg-file-upload:hover path {
  fill: #2f8ce7;
}

svg.svg-btn-submit {
  cursor: pointer;
  width: 44px;
  height: 44px;
}

.write-area .reply_original-content-group {
  position: absolute;
  width: calc(100% - 70px);
  vertical-align: top;
  margin: 5px;
  z-index: 1;
}

.reply_original-content-group .user-name {
  color: #fff;
}

.reply_original-content-group .user-comment {
  color: #ccc;
  font-weight: normal;
  overflow-y: hidden;
  height: 1.4rem;
}
.reply_original-content{
  display: inline-block;
  vertical-align: top;
  margin-left: 5px;
  overflow: hidden;
  width: calc( 100% - 42px);
}
.reply_preview-image {
  width: 36px;
  height: 36px;
  display: inline-block;
  vertical-align: top;
  border-radius: 5px;
  overflow: hidden;
}
.reply_preview-image img {
  width: 100%;
}
.write-area .detail-form {
  display: inline-block;
  width: 100%;
  background: #fff;
}

.sel-image-view {
  position: absolute;
  top: -140px;
  height: 140px;
  width: 100%;
}

.sel-image-view.with-reply-comment {
  top: -186px;
}

.sel-image-view .sel-image-block {
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
}

.sel-image-view .sel-image {
  height: 120px;
  width: 120px;
  margin: 10px 0;
  outline: 0;
  border: 0;
}

.sel-reply-comment-view {
  position: absolute;
  width: 100%;
  height: 46px;
  top: -46px;

}

.close-btn-group {
  position: absolute;
  top: 8px;
  right: 8px;
}


.dimd {
  position: absolute;
  background-color: #000;
  width: 100%;
  height: 100%;
}

.dimd.dimd-dark {
  opacity: 0.7;
}

.dimd.dimd-gray {
  opacity: 0.8;
}

.inputform {
  padding: 5px;
}

.article-reply-control-group {
  display: inline-block;
  width: calc(100% - 70px);
  border-radius: 10px;
  border: 1px solid #eee;
  padding: 5px;
}

.article-reply-control-group .control-button {
  display: inline-block;
}

.article-reply-control-group .control-button svg {
  vertical-align: bottom;
  display: inline-block;
}

.submit-control-button {
  display: inline-block;
  margin-left: 9px;
  text-align: right;
  vertical-align: bottom;
}

.submit-control-button svg {
  vertical-align: bottom;
  display: inline-block;
}

.write-area textarea {
  ime-mode: active;
  width: calc(100% - 77px);
  border: 0;
  outline: 0;
  vertical-align: bottom;
  font-size: 14px;
  min-height: 26px;
  max-height: 80px;
  resize: none;
}

textarea::placeholder {
  color: #b7b7b7;
}

.write-area button {
  background: transparent;
  color: #0086ff;
  font-size: 16px;
  font-weight: 500;
}

.write-area button:active {
  background-color: rgba(0, 0, 0, 0.1) !important;
}

.icon-control {
  width: 32px;
  height: 32px;
  cursor: pointer;
}
</style>